export default [{
  path: '/renewal',
  name: 'Renewal',
  component: () => import('@/views/renewal/index.vue')
}]
